/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TagReference,
    TagReferenceFromJSON,
    TagReferenceFromJSONTyped,
    TagReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetPartialUpdate
 */
export interface AssetPartialUpdate {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AssetPartialUpdate
     */
    customFields?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {Array<TagReference>}
     * @memberof AssetPartialUpdate
     */
    tags?: Array<TagReference>;
    /**
     * 
     * @type {number}
     * @memberof AssetPartialUpdate
     */
    workflowState?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetPartialUpdate
     */
    timecode?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetPartialUpdate
     */
    set?: number | null;
}

export function AssetPartialUpdateFromJSON(json: any): AssetPartialUpdate {
    return AssetPartialUpdateFromJSONTyped(json, false);
}

export function AssetPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customFields': !exists(json, 'custom_fields') ? undefined : json['custom_fields'],
        'tags': !exists(json, 'tags') ? undefined : ((json['tags'] as Array<any>).map(TagReferenceFromJSON)),
        'workflowState': !exists(json, 'workflow_state') ? undefined : json['workflow_state'],
        'timecode': !exists(json, 'timecode') ? undefined : json['timecode'],
        'set': !exists(json, 'set') ? undefined : json['set'],
    };
}

export function AssetPartialUpdateToJSON(value?: AssetPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_fields': value.customFields,
        'tags': value.tags === undefined ? undefined : ((value.tags as Array<any>).map(TagReferenceToJSON)),
        'workflow_state': value.workflowState,
        'timecode': value.timecode,
        'set': value.set,
    };
}


